module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_1.7b78dd6a.png";